import type { ArtworkPublic } from '../../shared/types';

interface GridProps {
  items: ArtworkPublic[];
  onOpen: (index: number) => void;
}

export function Grid({ items, onOpen }: GridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {items.map((it, i) => (
        <Tile key={it.id} item={it} onClick={() => onOpen(i)} />
      ))}
    </div>
  );
}

function Tile({ item, onClick }: { item: ArtworkPublic; onClick: () => void }) {
  const aspect =
    item.thumb_width && item.thumb_height
      ? `${item.thumb_width} / ${item.thumb_height}`
      : '4 / 5';
  return (
    <button
      type="button"
      onClick={onClick}
      className="group block overflow-hidden rounded-2xl border border-ink-900/5 bg-white text-left shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-ink-900/20"
    >
      <div className="overflow-hidden bg-canvas-100" style={{ aspectRatio: aspect }}>
        <img
          src={item.thumb_url}
          alt={item.title}
          loading="lazy"
          decoding="async"
          width={item.thumb_width ?? undefined}
          height={item.thumb_height ?? undefined}
          className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]"
        />
      </div>
      <div className="p-4">
        <div className="font-display text-base font-semibold text-ink-900">{item.title}</div>
        <div className="mt-1 text-xs text-ink-500">
          {item.category.name}
          {item.tags.length > 0 && (
            <>
              {' • '}
              {item.tags.slice(0, 3).map((t) => `#${t.name}`).join(' ')}
            </>
          )}
        </div>
      </div>
    </button>
  );
}
